import React from 'react';

const LoadingSpinner = () => {
    return (
        <div className="loadingio-spinner-dual-ring-6olokiydt0m d-flex m-auto">
            <div className="ldio-ilaxoqe1mn m-auto">
                <div></div>
                <div>
                    <div></div>
                </div>
            </div>
        </div>
    )
}

export default LoadingSpinner;